import { Routes, Route } from 'react-router-dom';
import SensorNew from '../../../pages/manage_database/SensorNew';
import SensorChoice from '../../../pages/manage_database/SensorChoice';
import SensorDelete from '../../../pages/manage_database/SensorDelete';
import SensorRecord from '../../../pages/manage_database/SensorRecord';


const SensorRoutes = () => {
    return <Routes>
         <Route 
            path='/new'
            element={<SensorNew />}
          />
          <Route 
            path='/choice'
            element={<SensorChoice />}
          />
          <Route 
            path='/delete'
            element={<SensorDelete />}
          />
          <Route 
            path='/record/:sensor_id'
            element={<SensorRecord />}
          />
    </Routes>
}

export default SensorRoutes;